import { render, staticRenderFns } from "./bbs.vue?vue&type=template&id=66a34104&scoped=true&"
import script from "./bbs.vue?vue&type=script&lang=js&"
export * from "./bbs.vue?vue&type=script&lang=js&"
import style0 from "./bbs.vue?vue&type=style&index=0&lang=less&"
import style1 from "./bbs.vue?vue&type=style&index=1&id=66a34104&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a34104",
  null
  
)

export default component.exports